let prev = document.getElementById("prev");
let next = document.getElementById("next");
let image = document.querySelector(".images");
let items = document.querySelectorAll(".images .item");
let contents = document.querySelectorAll(".content .item");
const bg = document.querySelector(".bg");

let active = 0; // Tracks the active item
const countItem = items.length;
const rotateAdd = 360 / countItem; // Rotation step per item
let currentRotation = 0; // Tracks current rotation of the container

const GRADIENTS = [
  { color: "#009047", gradient: "radial-gradient(circle farthest-side at center bottom, #fff 25%, #8bcf93 50%, #009047)" },
  { color: "#EF495F", gradient: "radial-gradient(circle farthest-side at center bottom, #fff 25%, #f49ea5 50%, #EF495F)" },
  { color: "#7757A4", gradient: "radial-gradient(circle farthest-side at center bottom, #fff 25%, #a08ec0 50%, #7757A4)" },
  { color: "#138145", gradient: "radial-gradient(circle farthest-side at center bottom, #fff 25%, #a7d1bb 50%, #138145)" },
  { color: "#DE4522", gradient: "radial-gradient(circle farthest-side at center bottom, #fff 25%, #f1a187 50%, #DE4522)" },
];

function nextSlider() {
  // Make "Next" go counterclockwise (previous behavior of prevSlider)
  active = (active - 1 + countItem) % countItem; // Decrement active index
  currentRotation += rotateAdd; // Adjust rotation for counterclockwise movement
  show(); // Update the display
}

function prevSlider() {
  // Make "Previous" go clockwise (previous behavior of nextSlider)
  active = (active + 1) % countItem; // Increment active index
  currentRotation -= rotateAdd; // Adjust rotation for clockwise movement
  show(); // Update the display
}

// Function to update the slider display
function show() {
  // Apply the calculated rotation
  image.style.setProperty("--rotate", `${currentRotation}deg`);

  // Update each item's image height and rotation
  items.forEach((item, index) => {
    const img = item.querySelector("img");
    if (index === active) {
      img.style.height = "25%"; // Highlight the active image
      img.style.transform = "rotate(360deg)"; // Reset rotation for the active image
      img.style.marginTop = "-5%";
    } else {
      img.style.height = "12%"; // Shrink non-active images
      img.style.transform = "rotate(0)"; // Rotate non-active images by 180 degrees
      img.style.marginTop = "0";
    }
  });

  // Update active content visibility
  contents.forEach((content, key) => {
    content.classList.toggle("active", key === active); // Show active content
  });

  // Update the background and title color
  const activeContent = contents[active];
  if (activeContent) {
    const activeTitle = activeContent.querySelector(".item-title");
    if (activeTitle) {
      const { color, gradient } = GRADIENTS[active % GRADIENTS.length] || {};
      activeTitle.style.color = color || "#fff"; // Default to white
      bg.style.background = gradient || "transparent"; // Default to transparent
    }
  }

  // Adjust the background image hue
  const bgImage = document.querySelector(".bg img");
  if (bgImage) {
    const hueValue = active * rotateAdd; // Adjust hue rotation
    bgImage.style.setProperty("filter", `hue-rotate(${hueValue}deg)`);
  }
}

// Initialize event listeners
// document.addEventListener("DOMContentLoaded", function () {
//   if (next && prev) {
//     next.onclick = nextSlider;
//     prev.onclick = prevSlider;
//     show(); // Initialize the display
//   } else {
//     console.error("Navigation elements 'next' or 'prev' not found.");
//   }
// });


// Initialize event listeners
document.addEventListener("DOMContentLoaded", function () {
  const nicciCart = document.querySelector('.nicci-cart'); 
  const navLinks = document.querySelectorAll('.nicci-header-link');
  const accountIcon = document.querySelector('.header__icon');
  const spanElement = document.querySelector(".navigation-btn span");
  
  if (window.location.pathname !== '/') {
    nicciCart.style.setProperty("fill", "#101010");
    accountIcon.style.setProperty("color", "#101010");
    spanElement.style.setProperty("background-color", "#101010");
    spanElement.style.setProperty("--before-bg-color", "#101010");
    navLinks.forEach(link => {
      link.style.color = '#101010';
    });
  } else {
    nicciCart.style.setProperty("fill", "#FFFFFF");
    accountIcon.style.setProperty("color", "#fff");
    spanElement.style.setProperty("background-color", "#fff");
    spanElement.style.setProperty("--before-bg-color", "#fff");
    navLinks.forEach(link => {
      link.style.color = '#fff';
    });
  }
  
  if (next && prev) {
    next.onclick = nextSlider;
    prev.onclick = prevSlider;
    show(); // Initialize the display
  } else {
    console.error("Navigation elements 'next' or 'prev' not found.");
  }

  // Active links for header
  const links = document.querySelectorAll(".nicci-header-link");
  links.forEach((link) => {
    const linkPath = link.getAttribute("data-active-link");
    if (
      window.location.pathname.includes(linkPath) ||
      (linkPath === "home" && window.location.pathname === "/")
    ) {
      link.classList.add("active");
    }

    link.addEventListener("click", function () {
      links.forEach((l) => l.classList.remove("active"));
      this.classList.add("active");
    });
  });

  // Initialize rotation step for CSS
  const imageContainer = document.querySelector(".images");
  const items = document.querySelectorAll(".images .item");

  // Calculate rotation step dynamically
  const rotationStep = 360 / countItem;

  // Set the CSS variable for the rotation step
  imageContainer.style.setProperty("--rotation-step", `${rotationStep}deg`);

  // Apply index-based rotation
  items.forEach((item, index) => {
    item.style.setProperty("--i", index);
  });
});


